import { withProps, compose } from 'recompose';
import { withRouter } from 'react-router';
import { get } from 'lodash';
import WithShop from './WithShop';
import WithKioskUrlPattern from './WithKioskUrlPattern';
import { generateUrlString } from '../utils/helpers';
import { ANY_BARBER } from '../constants';

export default compose(
  withRouter,
  WithShop,
  WithKioskUrlPattern,
  withProps((props) => {
    const startFromAnyBarber = get(props, 'location.query.startFromAnyBarber', false);
    const shopRoute = get(props, 'shop.route');
    const redirect = startFromAnyBarber ?
      generateUrlString({ shopRoute, barberRoute: ANY_BARBER }, props.urlPattern) :
      generateUrlString({ shopRoute }, props.urlPattern);

    return { homeUrl: redirect };
  }),
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithKioskHomeUrl.js